import { ServiceCallItem } from "./service-calls-response";

const row = ({
    notificationType,
    fullMachineName,
    status,
    sisCaseId,
    createdByUser,
    detailLink,
    creationDate,
    description,
}: ServiceCallItem): string => {
    return `
    <tr>
        <td>
           ${fullMachineName ?? "-"}
        </td>
        <td>
            <ux-w-status type="SERVICE_CALL_${status.type}">${status.text}</ux-w-status>
        </td>
        <td style="max-width: 400px" class="ux-table--no-wrap">
            <span class="ux-u-text-bold ux-table__copy-with-headline">${notificationType}</span>
            ${description || ""}
        </td>
        <td>${sisCaseId}</td>
        <td>${createdByUser}</td>
        <td>${creationDate}</td>
        <td>
            <ux-button size="icon" icon="chevron-right" href="${detailLink}"></ux-button>
        </td>
    </tr>
    `;
};

export default row;
